import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  data: null,
  error: '',
  checksum: '',
  updated: ''
}

const tearoom = createSlice({
  name: 'tearoom',
  initialState,
  reducers: {
    fetchTearoomMenuSuccess (state, action) {
      const { data, checksum, generated } = action.payload
      return {
        ...state,
        data,
        checksum,
        updated: generated,
        error: ''
      }
    },
    fetchTearoomMenuError (state, action) {
      const { detail } = action.payload
      return {
        ...state,
        error: detail
      }
    }
  }
})

const persistConfig = {
  key: 'tearoom',
  storage
}

export const { fetchTearoomMenuSuccess, fetchTearoomMenuError } =
  tearoom.actions
export const TearoomReducer = persistReducer(persistConfig, tearoom.reducer)
